import * as Yup from 'yup';

export const CompanyValidationSchema = Yup.object({
  companyName: Yup.string().required("Company name is required"),
  address: Yup.string().required("Address is required"),
  suite: Yup.string()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .optional(),
  city: Yup.string().required("City is required"),
  state: Yup.string().required("State is required"),
  zip: Yup.string().required("Zipcode is required"),
  website: Yup.string()
    .nullable()
    .transform((curr, orig) => (orig === "" ? null : curr))
    .test("website-format", "Invalid website URL", function (value) {
      if (!value || value === "") return true; // Allow empty values
      try {
        // Simple URL validation - check if it starts with http/https or www
        const urlPattern =
          /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;
        return urlPattern.test(value);
      } catch {
        return false;
      }
    })
    .optional(),
  //.url("Invalid website URL"), //.required("Company website is required"),
});
